import React from "react";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAppContext } from "../../Lib/ContextLib";
import SweetAlert from "react-bootstrap-sweetalert";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";

export default function AddMoney() {
  const { setShowPage, accessObject } = useAppContext();

  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [loader, setLoader] = React.useState(false);
  const [buttonLoader, setbuttonLoader] = React.useState(false);

  React.useEffect(() => {
    getBranch();
  }, []);

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/add-money/get-add-money`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);

        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const LoginSchema3 = Yup.object().shape({
    minAddMoney: Yup.string().required("required"),
    maxAddMoney: Yup.string().required("required"),
  });

  const successEdit = (msg) => {
    console.log("donw");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title=""
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      >
        <h4>{msg}</h4>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      <div class="content p-3 ">
        <div className="card p-3">
          {!loader && (
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  minAddMoney: tableData?.minAddMoney || "",
                  maxAddMoney: tableData?.maxAddMoney || "",
                }}
                validationSchema={LoginSchema3}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  let merged = { ...values, id: tableData?._id };
                  console.log("values", values);
                  axios(
                    `${API_URL}/api/admin/add-money/update-add-money/${tableData?._id}`,
                    {
                      method: "PATCH",
                      credentials: "include",
                      data: merged,
                    }
                  )
                    .then((result) => {
                      console.log("handleSubmit result :::", result.data);
                      setbuttonLoader(false);
                      successEdit(result.data.message);
                    })
                    .catch((err) => {
                      console.log("handleSubmit err :::", err);
                    });
                }}
              >
                {({ touched, errors, isSubmitting, values }) => (
                  <div className="p-2">
                    <Form>
                      <div className="row">
                        <div className="col-md-6 mb-4">
                          <label className="font-weight-bold text-muted small mb-2">
                            Min Add Money
                          </label>
                          <Field
                            type="number"
                            name="minAddMoney"
                            placeholder="Min Add Money"
                            disabled={!accessObject?.editAddMoney}
                            className={`form-control ${
                              touched.minAddMoney && errors.minAddMoney ? "is-invalid" : ""
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 15px",
                              border: "1px solid #e2e8f0",
                              backgroundColor: "#f8fafc",
                              height: "auto"
                            }}
                          />
                          <ErrorMessage
                            component="div"
                            name="minAddMoney"
                            className="invalid-feedback"
                          />
                        </div>

                        <div className="col-md-6 mb-4">
                          <label className="font-weight-bold text-muted small mb-2">
                            Max Add Money
                          </label>
                          <Field
                            type="number"
                            name="maxAddMoney"
                            placeholder="Max Add Money"
                            disabled={!accessObject?.editAddMoney}
                            className={`form-control ${
                              touched.maxAddMoney && errors.maxAddMoney ? "is-invalid" : ""
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 15px",
                              border: "1px solid #e2e8f0",
                              backgroundColor: "#f8fafc",
                              height: "auto"
                            }}
                          />
                          <ErrorMessage
                            component="div"
                            name="maxAddMoney"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>

                      {accessObject?.editAddMoney == true && (
                        <div className="mt-2">
                          <button
                            type="submit"
                            className="btn btn-warning font-weight-bold px-4"
                            disabled={buttonLoader}
                            style={{
                              borderRadius: "8px",
                              border: "none",
                              height: "45px",
                              boxShadow: "0 4px 6px -1px rgba(255, 193, 7, 0.2)",
                              color: "#000"
                            }}
                          >
                            <div className="d-flex align-items-center justify-content-center">
                              <span>Submit</span>
                              {buttonLoader && (
                                <div
                                  className="spinner-border spinner-border-sm ml-2"
                                  role="status"
                                ></div>
                              )}
                            </div>
                          </button>
                        </div>
                      )}
                    </Form>
                  </div>
                )}
              </Formik>
            </Box>
          )}
          {loader && <Loader />}
        </div>
      </div>
    </>
  );
}
